import $ from 'jquery';
import API from '../endpoints.json';

const saveMasterData = (key, data) =>
    dispatch => $.post(API[key], data);

const fetchMasterData = (key, options) =>
    dispatch => $.get(API[key], options);

const updateMasterData = (key, id, data) =>
    dispatch => $.ajax({
        url: API[key] + `/${id}`,
        type: 'PUT',
        data: data,
    });

const updateEFBData = (key, data) =>
    dispatch => $.ajax({
        url: API[key],
        type: 'PUT',
        data: data,
    });

const deleteMasterData = (key, id) =>
    dispatch => $.ajax({
        url: API[key] + `/${id}`,
        type: 'DELETE',
    });

export {
    saveMasterData,
    fetchMasterData,
    updateMasterData,
    updateEFBData,
    deleteMasterData,
}